import React, { useEffect } from "react";
import HelmetLayout from "../components/HelmetLayout/HelmetLayout";

import "../components/Styles/CookieTermsPrivacy.css";

const TermsAndConditions = () => {
  useEffect(() => {
    (function (d, s, id) {
      var js,
        tjs = d.getElementsByTagName(s)[0];
      // if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;

      js.src = "https://app.termly.io/embed-policy.min.js";

      tjs.parentNode.insertBefore(js, tjs);
    })(document, "script", "termly-jssdk");
  }, []);

  return (
    <div className="container">
      <HelmetLayout
        titleProps={`Terms and Conditions | Swifty Global`}
        children={
          <>
            <meta
              property="og:title"
              content="Terms and Conditions | Swifty Global"
              data-react-helmet="true"
            />
            <meta
              property="og:type"
              content="website"
              data-react-helmet="true"
            />
            <meta
              property="og:url"
              content="https://www.swifty.global/termsandconditions"
              data-react-helmet="true"
            />
          </>
        }
      />
      <div className="center-container">
        <div
          name="termly-embed"
          data-id="9ed61f4c-74cc-4f75-805c-4a24eadf8b6a"
          data-type="iframe"
        ></div>
      </div>

      {/* <CookieComponent /> */}
    </div>
  );
};

export default TermsAndConditions;
